import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { IonIcon } from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import { AuthContext } from '../context/AuthContext';
import { Form, Button, InputGroup } from 'react-bootstrap';
import AuthPage from '../components/layout/AuthPage';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { token, login } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/app/dashboard', { replace: true });
    }
  }, [token, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || ''}/api/login`, { email, password });
      const { token: jwtToken, user } = response.data;
      login(jwtToken, user);
      setError('');
      navigate('/app/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  if (token) {
    return null;
  }

  return (
    <AuthPage>
      <h1 className="auth-card__title">Garden Sync</h1>

      <Form onSubmit={handleLogin}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <InputGroup>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <InputGroup.Text onClick={() => setShowPassword(!showPassword)} className="peek-toggle">
              <IonIcon icon={showPassword ? eyeOff : eye} />
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>
        <Button type="submit" className="button w-100">
          Login
        </Button>
      </Form>

      <p className="text-center mt-3 mb-1">
        <span className="auth-link" onClick={() => navigate('/forgot-password')}>
          Forgot password?
        </span>
      </p>
      <p className="text-center mt-2 mb-0">
        <span className="auth-link" onClick={() => navigate('/about')}>
          Learn How To Join
        </span>
      </p>
      {error && <p className="text-danger text-center mt-3 mb-0">{error}</p>}
    </AuthPage>
  );
};

export default Login;